// extracted by mini-css-extract-plugin
module.exports = {"gameList":"_bdf28d3"};